/**
 * A status indicator that pairs a coloured dot with a word, always.
 *
 * Carried over from the dispatch board's convention, and it matters more here: this
 * app is read by operators in bad light, some of whom are colour-blind and many of
 * whom do not read English. Colour is decoration; the label is the message.
 */

export type StatusTone = 'good' | 'warning' | 'critical' | 'muted';

export interface StatusChipProps {
  readonly tone: StatusTone;
  readonly label: string;
}

const DOT_CLASS: Record<StatusTone, string> = {
  good: 'bg-good',
  warning: 'bg-warning',
  critical: 'bg-critical',
  muted: 'bg-ink-muted',
};

export function StatusChip({ tone, label }: StatusChipProps) {
  return (
    <span className="inline-flex items-center gap-2 text-ink-secondary">
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${DOT_CLASS[tone]}`} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
